exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-dashboard-container{min-height:600px}.no-supplier-headline{margin-left:35px}.all-platform-categories-container{max-width:210px}@media screen and (max-width:500px){.all-platform-categories-container{max-width:100%}}", ""]);

// exports
